import { IPageStatus } from './config/IPageStatus';
import Detail from './detail';
import styles from './index.module.scss';
import { useProductStore } from './ProductProvider';
import EfScrollAni from '@/efscrollani';

export default function ExampleProductA() {
    const { pageStatus } = useProductStore();

    if (typeof window !== 'undefined' && !window.AniContainer) {
        window.AniContainer = new EfScrollAni();
    }

    return (
        <div className={styles.page}>
            {pageStatus === IPageStatus.statusA && <Detail />}
            {pageStatus === IPageStatus.statusB && <Detail />}
            {pageStatus === IPageStatus.statusC && <Detail />}
        </div>
    );
}
